/**
 * UiSlice — global UI tercihleri (sunum modu, klavye shortcut yardım paneli).
 *
 * Persist edilmez (oturum-içi durum). Diğer slice'lardaki transcript /
 * audio / verdict mantığından bağımsız tutulur.
 */
import type { StateCreator } from "zustand";
import type { DebateStore } from "../debateStore";

export interface UiSlice {
  /** Tam ekran sunum modu — chrome'u gizler, tipografiyi büyütür. */
  presentMode: boolean;
  /** Klavye kısayollar yardım modal'ı. */
  shortcutsOpen: boolean;

  togglePresentMode(): void;
  setPresentMode(v: boolean): void;
  toggleShortcuts(): void;
  setShortcutsOpen(v: boolean): void;
}

export type UiSliceCreator = StateCreator<
  DebateStore,
  [["zustand/immer", never]],
  [],
  UiSlice
>;

export const createUiSlice: UiSliceCreator = (set) => ({
  presentMode: false,
  shortcutsOpen: false,

  togglePresentMode: () => {
    set((state) => {
      state.presentMode = !state.presentMode;
    });
  },
  setPresentMode: (v) => {
    set((state) => {
      state.presentMode = v;
    });
  },
  toggleShortcuts: () => {
    set((state) => {
      state.shortcutsOpen = !state.shortcutsOpen;
    });
  },
  setShortcutsOpen: (v) => {
    set((state) => {
      state.shortcutsOpen = v;
    });
  },
});
